import React from 'react';
import IconMi from 'components/common/icon/IconMi';
import { components } from 'react-select';
import { Box } from '@mui/material';

export const ReactSelectClearIndicator = (props: any) => {
    const filterSelectDataTest = props.selectProps['data-test'];

    return (
        <components.ClearIndicator {...props}>
            <Box data-test={filterSelectDataTest ? filterSelectDataTest + '-clear' : undefined} display={'flex'}>
                <IconMi
                    icon="times"
                    fontSize={'16'}
                    sx={{ color: 'text.primary', '&:hover': { color: 'error.main' } }}
                />
            </Box>
        </components.ClearIndicator>
    );
};
